import flatpickr from "flatpickr";
import {Spanish} from "flatpickr/dist/l10n/es.js";
import {French} from "flatpickr/dist/l10n/fr.js";
import {Portuguese} from "flatpickr/dist/l10n/pt.js";
import {Deutsch} from "flatpickr/dist/l10n/de.js";

export default class AvailableDatesCalendar {

    constructor(id, domElement, positionElement, functionOnChangeDates, functionInitializeView, onDayCreate,  minDate, maxDate, showMonths, enableDates) {
        this.id = id;
        this.domElement = domElement;
        this.positionElement = positionElement;
        this.functionOnChangeDates = functionOnChangeDates;
        this.functionInitializeView = functionInitializeView;
        this.onDayCreate = onDayCreate;
        this.isClearing = false;

        this.config = {
            showMonths: showMonths,
            minDate: minDate,
            maxDate: maxDate,
            mode: 'range',
            disableMobile: "true",
            altInput: true,
            altFormat: "j M Y",
            ariaDateFormat: 'm/d/Y',
            dateFormat: "j M Y",
            locale: {
                rangeSeparator: ' - ',
            },
            monthSelectorType: 'static',
            closeOnSelect: false,
            inline: true,
            onDayCreate: this.onDayCreate,
            onChange: this.functionOnChangeDates,
            enable: enableDates,
            allowInvalidPreload: true,
        };
        flatpickr.localize(this.getLocalizeFromLocale());
        this.element = flatpickr(this.domElement, this.config);
        this.element.calendarContainer.setAttribute('data-calendar-container', this.id);
        this.functionInitializeView();
        this.setView();
    }

    setView(scroll = true) {
        let calendarContainer = document.querySelector('[data-calendar-container="available-dates-calendar"]')
        let daysArray = calendarContainer.querySelectorAll('.dayContainer');
        let monthArray = calendarContainer.querySelectorAll('.flatpickr-month');
        let weekDaysContainer = calendarContainer.querySelectorAll('.flatpickr-weekdaycontainer');
        let calendarOptionsContainerHeight = document.querySelector('[data-entity="dates-calendar-options-container"]').offsetHeight;

        daysArray.forEach((element, key) => {
            let date = new Date(element.querySelector('.flatpickr-day:not(.hidden)').getAttribute('aria-label'));
            let currentMonth = myApp.dateFormatter.getShortDate(date, '/', true);
            element.setAttribute('data-entity', currentMonth);
            monthArray[key].style.top = (element.offsetTop + calendarOptionsContainerHeight) + 'px';
            weekDaysContainer[key].style.top = (element.offsetTop + monthArray[key].offsetHeight + calendarOptionsContainerHeight) +'px';
        });

        let startRange = this.element.daysContainer.querySelector('.startRange');

        if (startRange && startRange.parentElement && startRange.parentElement.previousElementSibling){
            let daysPrevMonth = startRange.parentElement.previousElementSibling.querySelectorAll('.flatpickr-day');
            if (daysPrevMonth && scroll) {
                let monthToScroll = daysPrevMonth[daysPrevMonth.length - 1];
                if (monthToScroll !== undefined) {
                    monthToScroll.scrollIntoView();
                }
            }
        }
    }

    getDefaultMinDate() {
        const minDate = new Date();
        minDate.setHours(0, 0, 0, 0);
        return minDate;
    }

    setDate(date) {
        this.element.setDate(date, false);
    }

    setMinDate(date) {
        this.element.config.minDate = date;
    }

    setMaxDate(date) {
        this.element.config.maxDate = date;
    }

    open() {
        this.element.open();
    }

    close() {
        this.element.close();
    }

    toggle() {
        this.element.toggle();
    }

    jumpToDate(date) {
        this.element.jumpToDate(date, true)
    }

    redraw() {
        this.element.redraw();
    }

    clear() {
        this.isClearing = true;
        this.element.clear();
        this.isClearing = false;
    }

    getLocalizeFromLocale() {
        switch (myApp.config.locale) {
            case 'es':
                return Spanish;
            case 'en':
                return 'en';
            case 'fr':
                return French;
            case 'pt':
                return Portuguese;
            case 'de':
                return Deutsch;
            default:
                return Spanish
        }
    }
}
